module.exports = __webpack_public_path__ + "img/shapes.0b4c5ed9.png";